import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import ScheduleIcon from '@mui/icons-material/Schedule'
import WebhookIcon from '@mui/icons-material/Webhook'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import HubIcon from '@mui/icons-material/Hub'
import BaseNode from './BaseNode'
import { TriggerNodeData } from '../types'

const TRIGGER_ICONS: Record<string, FC<{ fontSize?: 'small' }>> = {
  cron: ScheduleIcon,
  webhook: WebhookIcon,
  manual: PlayArrowIcon,
  mcp: HubIcon,
}

const TriggerNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as TriggerNodeData
  const Icon = TRIGGER_ICONS[nodeData.triggerType] ?? PlayArrowIcon

  const getSubtitle = (): string => {
    switch (nodeData.triggerType) {
      case 'cron':
        return nodeData.cronExpression ?? 'No schedule set'
      case 'webhook':
        return nodeData.webhookPath ?? 'No webhook path set'
      case 'manual':
        return 'Manual trigger'
      case 'mcp':
        return nodeData.mcpToolName
          ? `tool: ${nodeData.mcpToolName}`
          : 'MCP tool name not set'
      default:
        return ''
    }
  }

  return (
    <BaseNode
      nodeType="trigger"
      icon={<Icon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={getSubtitle()}
      selected={selected}
      handles={[
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(TriggerNode)
